import React from 'react'
import { useFormikContext } from 'formik'
import DayPicker, { DateUtils } from 'react-day-picker'
import dayjs from 'dayjs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons'

import Label from '../../utils/Label'
import RequestFormValidationError from './ValidationError'

// DayPicker-wrapper
// DayPicker-Months
// DayPicker-Month
// DayPicker-NavBar
// DayPicker-NavButton
// DayPicker-Caption
// DayPicker-Weekdays
// DayPicker-Weekday
// DayPicker-WeekdaysRow
// DayPicker-Body
// DayPicker-Week
// DayPicker-Day
// DayPicker-WeekNumber
// DayPicker--interactionDisabled .DayPicker-Day
// DayPicker-Footer
// DayPicker-TodayButton
// DayPicker-Day--today
// DayPicker-Day--outside
// DayPicker-Day--disabled
// DayPicker-Day--selected

const Navbar = ({ onPreviousClick, onNextClick, className }) => {
  const styleLeft = {
    float: 'left'
  }
  const styleRight = {
    float: 'right'
  }
  return (
    <div className={className}>
      <button type="button" style={styleLeft} onClick={() => onPreviousClick()}>
        <FontAwesomeIcon icon={faChevronLeft} className="text-3xl" />
      </button>
      <button type="button" style={styleRight} onClick={() => onNextClick()}>
        <FontAwesomeIcon icon={faChevronRight} className="text-3xl" />
      </button>
    </div>
  )
}

const RequestFormDateRange = () => {
  const requestForm = useFormikContext()

  const handleDayClick = day => {
    const range = DateUtils.addDayToRange(day, {
      from: requestForm.values.dateStart,
      to: requestForm.values.dateEnd
    })
    requestForm.setFieldValue('dateStart', range.from)
    requestForm.setFieldValue('dateEnd', range.to)
  }
  const handleResetClick = e => {
    e.preventDefault()
    requestForm.setFieldValue('dateStart', null)
    requestForm.setFieldValue('dateEnd', null)
  }

  return (
    <div className="w-full md:w-7/12 lg:w-1/2">
      <div className="h-12">
        {!requestForm.values.dateStart && !requestForm.values.dateEnd && (
          <Label className="mb-4">
            Select the <span className="text-orange-600">first day</span> you are available to arrive.
          </Label>
        )}
        {requestForm.values.dateStart && !requestForm.values.dateEnd && (
          <Label className="mb-4">
            Select the <span className="text-orange-600">last day</span> you are available to arrive.
          </Label>
        )}

        {requestForm.values.dateStart && requestForm.values.dateEnd && (
          <div className="flex space-x-4 items-center">
            <Label>Arriving:</Label>
            <div className="flex-grow flex items-center justify-between text-lg font-semibold p-2 border border-gray-200 bg-gray-100 text-gray-600 rounded-md">
              <FontAwesomeIcon icon={faCalendarAlt} />
              <span>
                {dayjs(requestForm.values.dateStart).format('MM/DD/YYYY')} -{' '}
                {dayjs(requestForm.values.dateEnd).format('MM/DD/YYYY')}
              </span>
              <FontAwesomeIcon icon={faTimes} onClick={handleResetClick} />
            </div>
          </div>
        )}
      </div>
      <div className="mt-8">
        <DayPicker
          numberOfMonths={1}
          selectedDays={[
            requestForm.values.dateStart,
            { from: requestForm.values.dateStart, to: requestForm.values.dateEnd }
          ]}
          onDayClick={handleDayClick}
          showOutsideDays
          pagedNavigation
          modifiers={{
            disabled: { before: new Date() }
          }}
          navbarElement={<Navbar />}
        />
        <RequestFormValidationError name='dateStart' />
      </div>
    </div>
  )
}
export default RequestFormDateRange
